<template>

    <!-- Sekcja OpenUp -->
<div :id="component_data.id">
    <div class="feat_wrapper font-responsive lg:hide">
        <div class="feat_contents w-5/6 mobile:w-full mobile:flex-column mx-auto">
            <div class="feat_visual w-1/2 mobile:w-full">
                <div class="feat_photo-big no_video">
                    <img class="tab_photo-big--inner" :src="component_data.params.img.src" :alt="component_data.params.img.alt">
                </div>
            </div>
            <article class="feat_caption w-2/5 mobile:w-full mobile-sides mx-auto">
                <header>
                    <figure class="feat_icon" v-html="component_data.params.icon"></figure>
                    <h2 v-html="component_data.params.title"></h2>
                </header>
                <div class="feat_texts">
                    <p v-for="(text, index) in texts(component_data.params)" v-html="text" :key="index"></p>
                </div>
            </article>
        </div>
    </div>

    <section class="custom04_section mobile:hide">
        <div class="custom04_wrapper font-responsive" :class="{playing: playing, 'playing-back': returning}">
            <div class="custom04_contents" :style="'background-image: url('+component_data.params.bg+');'">
                <video ref="custom04_video" class="custom04_video mobile:hide" muted @ended="finishPlayback()">
                    <source :src="component_data.params.vid.url" type="video/mp4">
                </video>
                <img class="custom04_img mobile:hide" :src="component_data.params.img.src" :alt="component_data.params.img.alt">
                <article class="custom04_caption w-2/5 mobile:w-full">
                    <header>
                        <figure class="custom04_icon" v-html="component_data.params.icon"></figure>
                        <h2 v-html="component_data.params.title"></h2>
                    </header>
                    <div class="custom04_texts">
                        <p v-for="(text, index) in texts(component_data.params)" v-html="text" :key="index"></p>
                    </div>
                </article>
                <button @click="startAnimation()" class="playButton btn_reset mobile:hide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320"><defs></defs><g transform="translate(-732 -926.75)"><g class="a" transform="translate(732 926.75)"><circle class="c" cx="160" cy="160" r="160"/><circle class="d" cx="160" cy="160" r="158"/></g><path class="b" d="M22,90.75l50-37.5L22,15.75Z" transform="translate(851 1034)"/></g></svg></button>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
  props: ["component_data"],
  data() {
    return {
      playing: false,
      returning: false,
      firstPlay: true,
    };
  },
  methods: {
    finishPlayback() {
      this.returning = true;
      this.playing = false;
      setTimeout(() => {
        this.$refs.custom04_video.currentTime = 0;
        this.returning = false;
      }, 800);
    },
    startAnimation() {
      this.firstPlay = false;
      this.playing = true;
      setTimeout(() => {
        this.$refs.custom04_video.play();
      }, 800);
    },
    isVideoInViewport() {
      let video = this.$refs.custom04_video;
      if (video) {
        var bounding = video.getBoundingClientRect();
        return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <=
            (window.innerHeight + 80 ||
              document.documentElement.clientHeight + 80) &&
          bounding.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
      }
    },
    handleScroll() {
      if (this.firstPlay && this.isVideoInViewport()) {
        this.startAnimation();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.firstPlay && this.isVideoInViewport()) {
        this.startAnimation();
      }
    });
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
.custom04_section {
  padding: 1px;
  overflow: hidden;
}

.custom04_wrapper {
  position: relative;
  width: 87.5%;
  margin: 6em auto 30em 8.33%;
}

.custom04_wrapper::after {
  content: "";
  height: 98%;
  width: 104.2%;
  right: 5%;
  top: 18.05%;
  position: absolute;
  background-color: #e41429;
  background: linear-gradient(to right, #ae0b11, #e41429);
  z-index: -1;
}
.custom04_wrapper::before {
  content: "";
  display: block;
  padding-bottom: 43.11%;
  width: 100%;
}
.custom04_contents {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: grey;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-top-right-radius: 6em;
}
.custom04_contents::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  border-top-right-radius: 6em;
  overflow: hidden;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.8) 50%,
    rgba(0, 0, 0, 0.9)
  );
}
.custom04_caption {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 6em 0 auto;
  z-index: 0;
}
.custom04_caption header {
  display: flex;
  align-items: center;
  margin-bottom: 4.5em;
  margin-top: 12.9em;
}
.custom04_caption header h2 {
  color: #fff;
  line-height: 1.41em;
  font-size: 3.8em;
  font-weight: 700;
  margin: 0 0 0 1.25em;
  padding-right: 0.625em;
  font-family: "Uni Neue", sans-serif;
}
.custom04_texts {
  padding: 0 3em;
}
.custom04_caption p {
  font-size: 2em;
  line-height: 1.9em;
  font-family: "Lato", sans-serif;
  color: #fff;
}
.custom04_icon {
  margin: 0;
}
.custom04_icon svg {
  width: 10em;
  height: 10em;
  border-radius: 8px;
  color: white;
  background-color: #e41429;
  margin: 0;
}
.custom04_img {
  max-width: 100%;
  width: 37.1%;
  position: absolute;
  left: 0;
  top: 40%;
}
.custom04_wrapper::after {
  border-bottom-left-radius: 6em;
}

.custom04_video {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-top-right-radius: 6em;
  overflow: hidden;
  opacity: 0;
}

/* Animacja */

.playButton,
.custom04_caption,
.custom04_img,
.custom04_video {
  animation-duration: 800ms;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}

/* Animacja:Start */
.playing .custom04_contents::before {
  animation-delay: 600ms;
}

.playing .playButton,
.playing .custom04_caption {
  animation-name: fade_out;
}
.playing .custom04_img {
  animation-name: slide_out;
}

.playing .custom04_video {
  animation-delay: 600ms;
  animation-name: fade_in;
}

/* Animacja:Powrót */
.playing-back .custom04_contents::before {
  animation-delay: 0ms;
}
.playing-back .playButton,
.playing-back .custom04_caption {
  animation-delay: 600ms;
  animation-name: fade_in;
}
.playing-back .custom04_img {
  animation-name: slide_in;
}
.playing-back .custom04_video {
  animation-name: fade_out;
  animation-delay: 0ms;
}

@keyframes fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade_out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes slide_out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(50%);
  }
}
@keyframes slide_in {
  from {
    transform: translateY(50%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
<style scoped>
.playButton {
  width: 32em;
  height: 32em;
  cursor: pointer;
  position: absolute;
  top: 2em;
  left: 23em;
}
.a,
.d {
  fill: none;
}
.a {
  stroke: #fff;
  stroke-width: 4px;
  stroke-dasharray: 20;
}
.b {
  fill: #e41429;
}
.c {
  stroke: none;
}

.feat_photo-big .tab_photo-big--inner {
  border-top-left-radius: 6em;
  overflow: hidden;
}
.feat_video.feat_video_l {
  content: "";
  position: absolute;
  height: 15.49vw;
  width: 25vw;
  right: -16%;
  bottom: -6em;
}
.feat_photo-big::before {
  content: "";
  position: absolute;
  height: 15.49vw;
  width: 25vw;
  z-index: -1;
  bottom: -3em;
  right: 0;
  transform: translateX(6em);

  border-bottom-right-radius: 3em;
  background: linear-gradient(to right, #ae0b11, #e41429);
}
.feat_photo-big.no_video::before {
}
@media (min-width: 1920px) {
  .feat_photo-big {
    width: 620px;
    height: 680px;
  }
  .feat_video.feat_video_l,
  .feat_photo-big::before {
    width: 461px;
    height: 285px;
  }
}
.feat_wrapper::before {
  border-top-right-radius: 6em;
  left: 0;
}
</style>
